// Mock admin auth for the MVP — credentials are intentionally hardcoded.
// Replace with real auth once a backend is introduced.
import { storage } from './storage';

export const ADMIN_DEMO = {
  username: 'admin',
  password: 'admin123',
  displayName: 'Admin · Brgy San Isidro',
  role: 'Administrator',
};

export const auth = {
  isLoggedIn() {
    return Boolean(storage.get('admin_session'));
  },
  login(username, password) {
    if (username === ADMIN_DEMO.username && password === ADMIN_DEMO.password) {
      storage.set('admin_session', {
        username,
        displayName: ADMIN_DEMO.displayName,
        role: ADMIN_DEMO.role,
        loggedAt: new Date().toISOString(),
      });
      return { ok: true };
    }
    return { ok: false, error: 'Invalid username or password.' };
  },
  logout() {
    storage.remove('admin_session');
  },
  user() {
    return storage.get('admin_session');
  },
};
